<template>
  <div class="dashboard__view merchant-list">
    <div class="page">
      <div class="page__title"></div>
      <div class="page__title__action">
        <router-link
          class="btn btn--primary"
          to="/dashboard/merchant/create"
          >Create Merchant</router-link
        >
      </div>
    </div>

    <div class="list">
      <div class="tab__content">
        <div class="tab__content__top">
          <div class="tab__content__top__left">
            {{ pageInfo.total }} Merchants
          </div>
          <div class="tab__content__top__right">
            <div class="tab__content__top__item">
              <button
                @click="clearFilter"
                class="btn btn--sm btn--default"
                v-if="openFilters"
              >
                Clear Filter
              </button>
            </div>
            <div class="tab__content__top__item">
              <button
                @click="openFilters = true"
                class="btn btn--sm btn--default"
              >
                Filter
              </button>
            </div>
          </div>
        </div>
        <div
          class="tab__content__top"
          style="padding-top: 0"
          v-if="openFilters"
        >
          <div class="tab__content__top__left">.</div>
          <div class="tab__content__top__right">
            <form @submit.prevent="triggerFilter">
              <div class="filter">
                <div class="form__item">
                  <div class="form__label">Merchant</div>
                  <input
                    class="form__input"
                    type="text"
                    v-model="filterList.merchant"
                  />
                </div>
                <div class="form__item">
                  <div class="form__label">Business</div>
                  <input
                    class="form__input"
                    type="text"
                    v-model="filterList.business"
                  />
                </div>
                <div class="form__item">
                  <div class="form__label">Status</div>
                  <div class="select select--border">
                    <select
                      class="select__input"
                      v-model="filterList.status"
                    >
                      <option value="ACTIVE">Active</option>
                      <option value="BLOCKED">Blocked</option>
                    </select>
                    <div class="select__icon">
                      <svg
                        height="10"
                        viewBox="0 0 6 10"
                        width="6"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"
                          fill="#637381"
                          fill-rule="evenodd"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
                <div class="form__item">
                  <div class="form__label">From Date</div>
                  <datepicker class="form__input" v-model="filterList.from" />
                </div>
                <div class="form__item">
                  <div class="form__label">To Date</div>
                  <datepicker class="form__input" v-model="filterList.to" />
                </div>
                <div class="form__item" style="padding-top: 33px">
                  <button
                    :disabled="disabled"
                    class="btn btn--primary btn--filter"
                    type="submit"
                  >
                    Apply Filter
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <EmptyState v-if="emptyState" type="not-found" icon="customer" />

        <div v-else>
          <!-- Loader -->
          <div class="loader" v-if="loading">
            <span aria-hidden="true" class="spinner-border"></span>
          </div>
          <table class="table card-table" v-else>
            <thead>
              <tr>
                <th>MERCHANT</th>
                <th>CONTACT</th>
                <th>CREATED DATE</th>
                <th>PLATFORM</th>
                <th>STATUS</th>
                <th>ACTION</th>
              </tr>
            </thead>
            <tbody>
              <router-link
                :key="key"
                :to="{ name: 'merchants-details', params: { id: item.id } }"
                tag="tr"
                v-for="(item, key) in merchantList"
              >
                <td>
                  <span class="name">{{ item.fullname }}</span>
                  <span class="email">{{ item.business_name }}</span>
                </td>
                <td>
                  <span class="name">{{ item.mobile_number }}</span>
                  <span class="email">{{ item.email }}</span>
                </td>
                <td>{{ item.created_at | date }}</td>
                <td>{{ item.onboarding_platform.replaceAll('_', ' ') || "N/A" }}</td>
                <td><status-indicator-with-words :type="item.status"/></td>
                <td class="act">
                  <b-dropdown
                    right
                    size="sm"
                    text="Action"
                    style="width: 200px;"
                  >
                    <router-link
                      :to="{
                        name: 'transaction-list',
                        query: { merchantId: item.id, page: '1' },
                      }"
                      class="act__item dropdown-item-list"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.19995 16V4"
                          stroke="#919EAB"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M2 7.42857L5.2 4L8.4 7.42857"
                          stroke="#919EAB"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M14.8 4V16"
                          stroke="#919EAB"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M11.6001 12.5714L14.8001 16L18.0001 12.5714"
                          stroke="#919EAB"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>

                      <span>View Transactions</span>
                    </router-link>

                    <router-link
                      :to="{
                        name: 'customers-list',
                        query: { merchantId: item.id, page: '1' },
                      }"
                      class="act__item dropdown-item-list"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.99996 4C8.65737 4 7.56519 5.25599 7.56519 6.80002C7.56519 8.34404 8.65734 9.60003 9.99996 9.60003C11.3426 9.60003 12.4347 8.34401 12.4347 6.80002C12.4347 5.25603 11.3426 4 9.99996 4ZM9.99996 8.8C9.04137 8.8 8.26085 7.9024 8.26085 6.80002C8.26085 5.69763 9.04137 4.80003 9.99996 4.80003C10.9586 4.80003 11.7391 5.69763 11.7391 6.80002C11.7391 7.9024 10.9586 8.8 9.99996 8.8Z"
                          fill="#919EAB"
                        />
                        <path
                          d="M14.8695 7.2002C13.9109 7.2002 13.1304 8.0978 13.1304 9.20019C13.1304 10.3026 13.9109 11.2002 14.8695 11.2002C15.8281 11.2002 16.6086 10.3026 16.6086 9.20019C16.6086 8.0978 15.8281 7.2002 14.8695 7.2002ZM14.8695 10.4002C14.2942 10.4002 13.826 9.8618 13.826 9.20019C13.826 8.53857 14.2942 8.00018 14.8695 8.00018C15.4448 8.00018 15.913 8.53857 15.913 9.20019C15.913 9.8618 15.4448 10.4002 14.8695 10.4002Z"
                          fill="#919EAB"
                        />
                        <path
                          d="M5.17978 7.2002C4.22047 7.2002 3.44067 8.0978 3.44067 9.20019C3.44067 10.3026 4.22119 11.2002 5.17978 11.2002C6.13837 11.2002 6.91889 10.3026 6.91889 9.20019C6.91889 8.0978 6.13906 7.2002 5.17978 7.2002ZM5.17978 10.4002C4.60447 10.4002 4.13631 9.8618 4.13631 9.20019C4.13631 8.53857 4.60447 8.00018 5.17978 8.00018C5.75509 8.00018 6.22325 8.53857 6.22325 9.20019C6.22325 9.8618 5.75506 10.4002 5.17978 10.4002Z"
                          fill="#919EAB"
                        />
                        <path
                          d="M9.99999 10.3999C7.50678 10.3999 5.47827 12.7327 5.47827 15.5999C5.47827 15.8207 5.63411 15.9999 5.82611 15.9999C6.01811 15.9999 6.17394 15.8207 6.17394 15.5999C6.17394 13.1735 7.89009 11.1999 9.99999 11.1999C12.1099 11.1999 13.826 13.1735 13.826 15.5999C13.826 15.8207 13.9819 15.9999 14.1739 15.9999C14.3659 15.9999 14.5217 15.8207 14.5217 15.5999C14.5217 12.7327 12.4932 10.3999 9.99999 10.3999Z"
                          fill="#919EAB"
                        />
                        <path
                          d="M14.8695 12C14.297 12 13.7363 12.18 13.248 12.52C13.0845 12.6352 13.0316 12.8808 13.1311 13.0696C13.2319 13.2584 13.4448 13.3184 13.609 13.204C13.9881 12.9392 14.4236 12.8 14.8695 12.8C16.2121 12.8 17.3043 14.056 17.3043 15.6C17.3043 15.8208 17.4601 16 17.6521 16C17.8441 16 18 15.8208 18 15.6C17.9999 13.6152 16.5954 12 14.8695 12Z"
                          fill="#919EAB"
                        />
                        <path
                          d="M6.75129 12.5192C6.26363 12.18 5.70296 12 5.13042 12C3.40451 12 2 13.6152 2 15.6C2 15.8208 2.15584 16 2.34783 16C2.53983 16 2.69567 15.8208 2.69567 15.6C2.69564 14.056 3.78783 12.8 5.13042 12.8C5.57634 12.8 6.01179 12.9392 6.39024 13.2032C6.55371 13.3176 6.76798 13.2576 6.86816 13.0688C6.96833 12.88 6.91544 12.6344 6.75129 12.5192Z"
                          fill="#919EAB"
                        />
                      </svg>

                      <span>View Customers</span>
                    </router-link>

                    <router-link
                      :to="{ name: 'merchant-edit', params: { id: item.id } }"
                      class="act__item dropdown-item-list"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.15659 3.68652H3.59035C3.16857 3.68652 2.76405 3.85408 2.4658 4.15233C2.16755 4.45058 2 4.8551 2 5.27689V16.4095C2 16.8313 2.16755 17.2358 2.4658 17.5341C2.76405 17.8323 3.16857 17.9999 3.59035 17.9999H14.7228C15.1446 17.9999 15.5491 17.8323 15.8474 17.5341C16.1456 17.2358 16.3132 16.8313 16.3132 16.4095V10.8432"
                          stroke="#919EAB"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M15.1203 2.49406C15.4367 2.17772 15.8657 2 16.3131 2C16.7605 2 17.1895 2.17772 17.5059 2.49406C17.8222 2.81041 17.9999 3.23946 17.9999 3.68684C17.9999 4.13422 17.8222 4.56328 17.5059 4.87962L9.9517 12.4339L6.771 13.2291L7.56617 10.0483L15.1203 2.49406Z"
                          stroke="#919EAB"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>

                      <span>Edit</span>
                    </router-link>

                    <router-link
                      :to="{
                        name: 'merchant-kyc-review',
                        params: { id: item.id },
                      }"
                      class="act__item dropdown-item-list"
                      v-if="item.status"
                    >
                      <!--                      v-if="item.status && item.status.split('_').join(' ').toLowerCase() === 'pending kyc review'"-->
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2 10C2 10 4.90909 4 10 4C15.0909 4 18 10 18 10C18 10 15.0909 16 10 16C4.90909 16 2 10 2 10Z"
                          stroke="#919EAB"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M9.99993 12.25C11.2049 12.25 12.1818 11.2426 12.1818 10C12.1818 8.75736 11.2049 7.75 9.99993 7.75C8.79495 7.75 7.81812 8.75736 7.81812 10C7.81812 11.2426 8.79495 12.25 9.99993 12.25Z"
                          stroke="#919EAB"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <span>View KYC Details</span>
                    </router-link>

                    <div class="act__item dropdown-item-list" @click.prevent="toggleMerchantStatus(item, key)">
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                              d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z"
                              :stroke="item.status !== 'BLOCKED' ? '#C61010' : '#29d450'"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                          />
                          <path
                              d="M4 5L15 16"
                              :stroke="item.status !== 'BLOCKED' ? '#C61010' : '#29d450'"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                          />
                        </svg>

                      <span
                          class="btn--noStyle red"
                          v-if="item.status !== 'BLOCKED' && item.status !== 'INACTIVE'"
                        >
                          <span v-if="deactivateDisabled[key]"
                            >Blocking...</span
                          >
                        <span v-else>Block</span>
                      </span>
                        <span
                            v-if="item.status == 'BLOCKED'"
                          class="btn--noStyle text-green"
                        >
                          <span v-if="activateDisabled[key]"
                            >Unblocking...</span
                          >
                          <span v-else>Unblock</span>
                        </span>
                    </div>
                    <div class="act__item dropdown-item-list" @click.prevent="downloadQR(item)" v-if="item.nibss_qrcode">
                      <svg style="height: 16px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M24 32C10.7 32 0 42.7 0 56L0 456c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24L64 56c0-13.3-10.7-24-24-24L24 32zm88 0c-8.8 0-16 7.2-16 16l0 416c0 8.8 7.2 16 16 16s16-7.2 16-16l0-416c0-8.8-7.2-16-16-16zm72 0c-13.3 0-24 10.7-24 24l0 400c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-400c0-13.3-10.7-24-24-24l-16 0zm96 0c-13.3 0-24 10.7-24 24l0 400c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-400c0-13.3-10.7-24-24-24l-16 0zM448 56l0 400c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-400c0-13.3-10.7-24-24-24l-16 0c-13.3 0-24 10.7-24 24zm-64-8l0 416c0 8.8 7.2 16 16 16s16-7.2 16-16l0-416c0-8.8-7.2-16-16-16s-16 7.2-16 16z"/></svg>
                      <span>Download QR</span>
                    </div>
                    <div
                    @click.prevent="navigateToLinks(item)"
                      class="act__item dropdown-item-list"
                    >
                      <svg data-v-106c86ed="" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect data-v-106c86ed="" x="5" y="5" width="4" height="4" fill="#919EAB"></rect><rect data-v-106c86ed="" x="11" y="5" width="4" height="4" fill="#919EAB"></rect><rect data-v-106c86ed="" x="5" y="11" width="4" height="4" fill="#919EAB"></rect><rect data-v-106c86ed="" x="11" y="11" width="2" height="2" fill="#919EAB"></rect></svg>
                      <span>View Payment Links</span>
                    </div>
                    <div class="act__item dropdown-item-list" @click.prevent="toggleMerchantDelete(item)" style="color: red !important;">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style="height: 16px; font-size: 16px;"><path d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3zM32 128l384 0 0 320c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-320zm96 64c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16z" fill="red"/></svg>
                      <span>Delete Merchant</span>
                    </div>
                  </b-dropdown>
                </td>
              </router-link>
            </tbody>
          </table>
            <div
            class="table__details"
            v-if="loading !== true && emptyState !== true"
          >
            <div class="table__details__left">
              <span class="text-muted" v-if="pageInfo.total"
                >Page {{ pageInfo.current_page }} of
                {{ pageInfo.total_pages }}</span
              >
            </div>
            <div class="table__details__right">
              <Pagination :numberOfPages="pageInfo.total_pages" />
            </div>
            <div class="table__details__right"></div>
          </div>
        </div>
      </div>
        <StatusUpdateConfirmation
          v-if="showUpdateStatus"
          @hide="hideUpdateModal"
          @confirmed="confirmStatusUpdate"
          :merchantToUpdate="merchantToUpdate"
        />
        <ConfirmDeleteMerchant
          v-if="showConfirmDelete"
          :merchantToDelete="merchantToDelete"
          @hide="hideUpdateModal"
          @confirmed="confirmMerchantDelete"
        />
    </div>
    <QRTemplate :qrPaymentDetails="qrPaymentDetails" v-if="qrPaymentDetails" :download="download" @downloadedqr="download = null"/>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import Pagination from "@/components/pagination.vue";
import Vue from "vue";
import EmptyState from "@/components/empty-state.vue";
import StatusIndicatorWithWords from '../../../components/statusIndicatorWithWords';
import StatusUpdateConfirmation from "./StatusUpdateConfirmation.vue";
import ConfirmDeleteMerchant from "../../../components/ConfirmDeleteMerchant";
import QRTemplate from "@/components/qrtemplate.vue";
export default {
  components: {
    StatusIndicatorWithWords,
    Datepicker,
    Pagination,
    EmptyState,
    StatusUpdateConfirmation,
    QRTemplate,
    ConfirmDeleteMerchant
  },
  metaInfo: {
    title: "Merchants",
  },
  data() {
    return {
      merchantList: "",
      pageInfo: "",
      perPage: 10,
      disabled: false,
      filterList: {
        merchant: this.$route.query.fullname ? this.$route.query.fullname : "",
        business: this.$route.query.business_name
          ? this.$route.query.business_name
          : "",
        status: this.$route.query.status ? this.$route.query.status : "",
        to: this.$route.query.to ? this.$route.query.to : "",
        from: this.$route.query.from ? this.$route.query.from : "",
      },
      activateDisabled: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ],
      deactivateDisabled: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ],
      loading: true,
      emptyState: false,
      openFilters: false,
      showUpdateStatus: false,
      showConfirmDelete: false,
      merchantToUpdate: {},
      merchantToDelete: {},
      qrPaymentDetails:null,
      download: null,
    };
  },

  created() {
    localStorage.removeItem('merchantInfo');
    this.fetchMerchants();
  },


  watch: {
    // call again the fetch method if the route changes; this is necessary especially because of users
    // using the search and might be on this route already.
    $route: "fetchMerchants",
  },

  methods: {
    hideUpdateModal() {
      this.showUpdateStatus = false;
      this.showConfirmDelete = false;
    },
    confirmStatusUpdate(event) {
      const { merchant, key, type } = event;
      this.showUpdateStatus = false;
      if (type === 'block') {
        this.deactivate(merchant, key);
      } else {
        this.activate(merchant, key);
      }
    },
    confirmMerchantDelete(event) {
      const merchant = event;
      this.showConfirmDelete = false;
      this.deleteMerchant(merchant);
    },
    generatePaginationLink(pageNum) {
      return {
        path: "/dashboard/merchants",
        query: {
          ...this.$route.query,
          page: pageNum,
        },
      };
    },
    triggerFilter() {
      let queryObject = {};
      if (this.filterList.merchant !== "") {
        queryObject.fullname = this.filterList.merchant.trim();
      }
      if (this.filterList.business !== "") {
        queryObject.business_name = this.filterList.business.trim();
      }
      if (this.filterList.status !== "") {
        queryObject.status = this.filterList.status;
      }
      if (this.filterList.to !== "") {
        queryObject.to = moment(this.filterList.to).format("YYYY-MM-DD 23:59:59");
      }
      if (this.filterList.from !== "") {
        queryObject.from = moment(this.filterList.from).format("YYYY-MM-DD 00:00:00");
      }

      queryObject.page = 1;
      this.openFilters = false;
      //Route to page with query
      this.$router.push({ path: "/dashboard/merchants", query: queryObject });
    },
    clearFilter() {
      this.filterList = {
        merchant: "",
        business: "",
        status: "",
        to: "",
        from: "",
      };
      this.$router.push({ path: "/dashboard/merchants?page=1" });
    },
    fetchMerchants() {
      // Convert object to multiple arrays with name and value
      let queryParams = Object.entries(this.$route.query);
      let generatedQuery = "";
      let i = 0;
      let appendedQuery = "&ignore_admin_flag=1";
      // Loop through arrays and generate the query string
      for (const [name, value] of queryParams) {
        generatedQuery += `${name}=${value}`;
        i++;
        if (i < queryParams.length) {
          generatedQuery += "&";
        }
      }

      // // check for mode to append query
      // if (this.mode) {
      //     appendedQuery = "&ignore_admin_flag=1";
      // } else {
      //     appendedQuery = "&ignore_admin_flag=1&is_test=1";
      // }

      this.$http
        .get(`admin/merchants?${generatedQuery}${appendedQuery}`)
        .then((response) => {
          if (response.body.data.merchants.length > 0) {
            this.merchantList = response.body.data.merchants;
            this.pageInfo = response.body.data.page_info;
            this.emptyState = false;
            this.loading = false;
          } else {
            this.loading = false;
            this.emptyState = true;
          }
        })
        .catch((error) => {
          // LOG Error
        });
    },

    resetState() {
      this.fullName.empty = false;
      this.businessName.empty = false;
      this.mobileNumber.empty = false;
      this.businessNuban.empty = false;
      this.password.empty = false;
      this.emailAddress.empty = false;
    },
    clearData() {
      this.fullName.value = "";
      this.businessName.value = "";
      this.mobileNumber.value = "";
      this.businessNuban.value = "";
      this.password.value = "";
      this.emailAddress.value = "";
    },
    deleteMerchant(merchant) {
      this.$http
        .delete(`dashboard/admin/merchant/${merchant.id}/inactive`)
        .then((response) => {
          this.$notify({
            group: "notifications-default",
            type: "success text-white",
            title: "Success",
            text: response.body.message,
          });
          this.merchantToDelete = null;
          this.fetchMerchants();
        })
        .catch((error) => {
          this.$notify({
            group: "notifications-default",
            type: "error text-white",
            title: "Error",
            text: error.body.message || "An error occurred",
          });
        });
    },

    deactivate(value, key) {
      // Since Arrays are not reactively we have to manually update the data.
      // (variable, array position, value)
      Vue.set(this.deactivateDisabled, [key], true);
      let requestObject = {
        status: "BLOCKED",
        id: value.id,
      };
      this.$http
        .put("admin/merchants", requestObject)
        .then((response) => {
          // Undisable button
          Vue.set(this.deactivateDisabled, [key], false);
          // Notifiy user
          this.$notify({
            group: "notifications-default",
            type: "success text-white",
            title: "Success",
            text: response.body.message,
          });
          // Update merchant list
          this.fetchMerchants();
          this.merchantToUpdate = null;
        })
        .catch((error) => {
          this.merchantToUpdate = null;
          Vue.set(this.deactivateDisabled, [key], false);
          this.$notify({
            group: "notifications-default",
            type: "error text-white",
            title: "Error",
            text: error.body.message,
          });
        });
    },
    activate(value, key) {
      Vue.set(this.activateDisabled, [key], true);
      let requestObject = {
        status: "ACTIVE",
        id: value.id,
      };
      this.$http
        .put("admin/merchants", requestObject)
        .then((response) => {
          // Undisable button
          Vue.set(this.activateDisabled, [key], false);
          // Notifiy user
          this.$notify({
            group: "notifications-default",
            type: "success text-white",
            title: "Success",
            text: response.body.message,
          });
          // Update merchant list
          this.fetchMerchants();
        })
        .catch((error) => {
          Vue.set(this.activateDisabled, [key], false);
          this.$notify({
            group: "notifications-default",
            type: "error text-white",
            title: "Error",
            text: error.body.message,
          });
        });
    },
    showConfirmStatusUpdate() {
      this.showUpdateStatus = true;
    },
    toggleMerchantStatus(value, key){
      if (value.status !== 'BLOCKED' && value.status !== 'INACTIVE') {
        this.merchantToUpdate = { merchant: value, key, type: 'block' };
      } else {
        this.merchantToUpdate = { merchant: value, key, type: 'unblock' };
      }
      this.showConfirmStatusUpdate();
    },
    toggleMerchantDelete(merchant){
      this.merchantToDelete = merchant;
      this.showConfirmDelete = true;
    },
    downloadQR(item) {
      this.qrPaymentDetails = {
        qrcode: item.nibss_qrcode,
        bank_name: "Wema Bank",
        account_number: item.qrcode_account_number,
        account_name: item.qrcode_account_name,
        merchant_name: item.business_name
      };
      this.download = "branded";
    },
    navigateToLinks(item) {
      localStorage.setItem("merchantInfo", JSON.stringify(item));
      this.$router.push({
        name: 'merchant-links',
        params: { id: item.id }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.merchant-list {
.create-merchant-btn {
  position: absolute;
  right: 20px;
  top: 10px;
}
.dropdown-item-list {
  display: flex;
  align-items: center;
  span {
    display: inline;
    padding-left: 10px;
  }
}
.pending {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #b59b00;
}
.name {
  color: #261940;
  display: block;
  margin-bottom: 4px;
}

.email {
  color: rgba(38, 25, 64, 0.6);
  font-size: 12px;
}

.page__link {
  color: rgba(38, 25, 64, 0.6);
  font-size: 14px;
  line-height: 20px;
  padding: 12px 24px;
  text-decoration: none;
  display: block;
  &:hover {
    color: #e00b5b;
  }
}
}
.text-green {
  color: #29d450 !important;
}
</style>
